import React, { useMemo } from 'react'
import { createAnimationLoop } from '../lib/createAnimationLoop'

export function useAnimationLoop(drawFrame: () => void, deps: React.DependencyList) {
  return useMemo(() => createAnimationLoop(drawFrame), deps)
}
